export default __webpack_public_path__ + "static/media/mic-slash.78819e8b.svg";